module.exports = __webpack_public_path__ + "img/icono-paquete.065eda17.svg";